import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import './switcher.scss'

interface SwitcherProps {
	label: string
	fieldName: string
}
const Switcher = ({ label, fieldName }: SwitcherProps) => {
	const [valueNumber, setValueNumber] = useState(0)
	const { register, setValue } = useFormContext()

	const increment = () => {
		const newValue = valueNumber + 1
		setValue(fieldName, newValue)
		setValueNumber(newValue)
	}
	const decrement = () => {
		if (valueNumber > 0) {
			const newValue = valueNumber - 1
			setValue(fieldName, newValue)
			setValueNumber(newValue)
		}
	}
	return (
		<div className="switcher-container">
			<label>{label}</label>
			<div className="switcher">
				<div className="switcher-element" onClick={decrement}>
					-
				</div>
				<div className="switcher-element">
					<input
						className="switcher-input"
						type="text"
						{...register(fieldName)}
						readOnly
						defaultValue={0}
					/>
				</div>
				<div className="switcher-element" onClick={increment}>
					+
				</div>
			</div>
		</div>
	)
}

export default Switcher
